<div class="card" *ngIf="topic">
    <div class="card-header">
        <a [routerLink]="['/admin/syllabus/show',topic.server_syllabus_id]" >
            <h4 class="text-center">
              Topic Name:  {{topic.name}} [[ {{topic.syllabusode}} ]]
              <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
            </h4>
        </a>

    </div>
    <div class="card-body">
        <table class="table table-striped">
            <tbody>
              <tr><td>Date Created</td><td>{{topic.datecreated}}</td></tr>
             <tr><td>Last Updated</td><td>{{topic.lastupdated}}</td></tr>
            <tr><td>Name</td><td [appMath]="topic.name" *ngIf="!loading"></td></tr>
            <tr><td>Description</td><td>{{topic.description}}</td></tr>
            <tr><td>Syllabus</td><td><a [routerLink]="['/admin/syllabus/show',topic.server_syllabus_id]" >{{topic.syllabuscode}}</a></td></tr>
            <tr>
                <td colspan="2">
                <h6> Sub Topics</h6>
                <ul>
                <li *ngFor="let subTopic of topic.subtopics;">
                    <span *ngIf="subTopic.is_open!=1" class="text-danger">Premium</span>
                    [{{subTopic.subtopiccode}}]
                    <a [routerLink]="['/admin/subtopic/show',subTopic.id]" >{{subTopic.name}}</a>[{{subTopic.questionTemplateCount}}][{{subTopic.answerTemplateCount}}]
            </li>
            </ul>
            </td></tr>
            </tbody>
           </table>
          <app-admin-syllabus-topic-edit [topic]="topic" (editTopicFinished)="reloadTopic()"> </app-admin-syllabus-topic-edit>
          <app-admin-syllabus-add-subtopic [topic]="topic" (addSubTopicFinished)="reloadTopic()"> </app-admin-syllabus-add-subtopic>
    </div>

    <div class="card-footer">
        <fieldset class="buttons text-center alert">

            <button  class="btn btn-primary me-2" (click)="editTopicPopUp()">Edit</button>
            <button  class="btn btn-primary me-2" (click)="addSubTopicPopUp()">Add SubTopic</button>
            <button   (click)="showDeleteAlert()" class="delete   btn btn-danger">Delete </button>
        </fieldset>
    </div>
</div>

